<h4 class="page-title"><i class="fe-star-on fa-lg" style="color: #f5b106;"></i> Avaliações de Pedidos</h4>

<div class="avaliacoes">
  <div class="resumo">
    <div class="resumo-card">
      <span class="resumo-rotulo">Nota média geral</span>
      <div class="resumo-nota">
        <span class="resumo-valor">{{(notaGeral?.media || 0) | number: '1.1-1'}}</span>
        <span class="estrelas estrelas-grandes">
          <span class="estrelas-fundo">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
          <span class="estrelas-cheias" [style.width.%]="percentualEstrelas(notaGeral?.media)">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
        </span>
      </div>
      <span class="resumo-qtde">{{notaGeral?.qtdeAvaliacoes || 0}} avaliações no total</span>
    </div>

    <div class="resumo-card">
      <span class="resumo-rotulo">Últimos 30 dias</span>
      <div class="resumo-nota">
        <span class="resumo-valor">{{(notaMediaUltimos30Dias?.media || 0) | number: '1.1-1'}}</span>
        <span class="estrelas estrelas-grandes">
          <span class="estrelas-fundo">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
          <span class="estrelas-cheias" [style.width.%]="percentualEstrelas(notaMediaUltimos30Dias?.media)">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
        </span>
      </div>
      <span class="resumo-qtde">{{notaMediaUltimos30Dias?.qtdeAvaliacoes || 0}} avaliações no período</span>
    </div>
  </div>

  <div class="lista">
    <div class="lista-topo">
      <span class="lista-titulo">Avaliações recebidas</span>
      <span class="lista-contagem" *ngIf="total > 0">{{inicio + 1}}–{{ultimoItemDaPagina}} de {{total}}</span>
    </div>

    <div class="lista-corpo" [class.carregando]="loading && avaliacoes.length">
      <div class="estado" *ngIf="loading && !avaliacoes.length">
        <i class="fas fa-spinner fa-spin spinner"></i>
        <span>Carregando avaliações…</span>
      </div>

      <div class="estado estado-erro" *ngIf="!loading && erro">
        <i class="fe-alert-circle"></i>
        <span>{{erro}}</span>
        <button type="button" class="btn btn-sm btn-light" (click)="carregue(inicio)">Tentar de novo</button>
      </div>

      <div class="estado" *ngIf="!loading && !erro && !avaliacoes.length">
        <i class="fe-star"></i>
        <span class="estado-titulo">Nenhuma avaliação ainda</span>
        <span>Quando os clientes avaliarem os pedidos, as notas e comentários aparecem aqui.</span>
      </div>

      <div class="avaliacao" *ngFor="let avaliacao of avaliacoes">
        <div class="avatar" [class.avatar-baixa]="avaliacao.nota <= 2">{{iniciais(avaliacao.pedido?.cliente?.nome)}}</div>

        <div class="avaliacao-conteudo">
          <div class="avaliacao-topo">
            <a class="cliente" [href]="'/admin/contatos/' + avaliacao.pedido?.cliente?.codigoPais + avaliacao.pedido?.cliente?.telefone">
              {{avaliacao.pedido?.cliente?.nome}}
            </a>
            <span class="avaliacao-data">
              {{avaliacao.data | date: 'dd/MM/yy'}}
              <span *ngIf="avaliacao.tempoAvaliarDescricao"> · {{tempoParaAvaliar(avaliacao)}} após o pedido</span>
            </span>
          </div>

          <div class="avaliacao-nota">
            <span class="estrelas" [class.estrelas-baixa]="avaliacao.nota <= 2">
              <span *ngFor="let estrela of estrelas" [class.cheia]="estrela <= avaliacao.nota">&#9733;</span>
            </span>
            <span class="chip" [class.chip-positivo]="avaliacao.gostouDaEntrega" [class.chip-negativo]="!avaliacao.gostouDaEntrega">
              <i class="fas" [class.fa-thumbs-up]="avaliacao.gostouDaEntrega" [class.fa-thumbs-down]="!avaliacao.gostouDaEntrega"></i>
              {{avaliacao.gostouDaEntrega ? 'Gostou da entrega' : 'Não gostou da entrega'}}
            </span>
          </div>

          <p class="comentario" *ngIf="avaliacao.comentario">“{{avaliacao.comentario}}”</p>
          <p class="comentario comentario-vazio" *ngIf="!avaliacao.comentario">Sem comentário</p>

          <div class="avaliacao-meta">
            <a class="meta-pedido"
               [routerLink]="(modoGrupoLojas ? ('/admin-grupo/pedidos/detalhes/' + avaliacao.pedido?.empresa?.id + '/') : '/admin/pedidos/detalhes/') + avaliacao.pedido?.guid">
              Pedido #{{avaliacao.pedido?.codigo}}
            </a>
            <span>{{avaliacao.pedido?.total | currency: 'BRL'}}</span>
            <span>{{avaliacao.pedido?.horarioVenda | date: 'dd/MM/yy HH:mm'}}</span>
            <app-pedido-origem [pedido]="avaliacao.pedido"></app-pedido-origem>
            <a class="meta-whatsapp" *ngIf="avaliacao.pedido?.cliente?.telefone"
               [href]="'/admin/contatos/' + avaliacao.pedido?.cliente?.codigoPais + avaliacao.pedido?.cliente?.telefone">
              <i class="fab fa-whatsapp"></i> {{avaliacao.pedido.cliente.telefone | mask: '(99) 9-9999-9999'}}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="lista-rodape" *ngIf="total > tamanhoPagina">
      <kendo-datapager
        [pageSize]="tamanhoPagina"
        [skip]="inicio"
        [total]="total"
        [buttonCount]="5"
        [info]="false"
        [pageSizeValues]="false"
        (pageChange)="mudouPagina($event)">
      </kendo-datapager>
    </div>
  </div>
</div>
